var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFellowship(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 138,
    viewBox: "0 0 192 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 137.331,
    rx: 9.79205,
    fill: "#E1E7F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M172.311 113.017H19.6038C19.6038 113.017 18.1758 97.1305 39.6852 98.482C39.6852 98.482 40.2462 75.0091 59.0398 79.2804C59.0398 79.2804 62.3293 69.5904 70.6679 75.5956C70.6679 75.5956 89.6655 37.9192 115.038 58.7018C117.69 60.8821 124.091 70.6869 119.756 80.3769C119.756 80.3769 133.271 74.8944 136.649 89.3785C141.915 111.933 152.74 94.81 163.399 101.593C174.045 108.363 172.311 113.017 172.311 113.017Z",
    fill: "#E4EEF7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4272 44.0518C86.4272 44.0518 92.1138 45.0208 92.7768 51.7273C92.9298 53.3211 92.9935 55.2718 92.8278 58.1406L86.95 51.8038L86.4272 44.0518Z",
    fill: "url(#paint0_linear_1_6936)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4728 48.9732L82.411 50.3884L72.8357 16.333C72.8357 16.333 81.6332 18.2073 84.6805 30.8936C85.7388 35.3434 86.4018 38.4034 87.4728 48.9732Z",
    fill: "url(#paint1_linear_1_6936)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7553 47.0479C75.7553 47.0479 71.4075 50.8474 74.3273 56.9036C75.0285 58.3444 75.9848 60.0402 77.6295 62.4117L79.3381 53.9329L75.7553 47.0479Z",
    fill: "url(#paint2_linear_1_6936)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6002 53.0788L87.4089 48.9351L82.3472 50.3631L83.5712 54.6981L87.6002 53.0788Z",
    fill: "url(#paint3_linear_1_6936)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4255 51.791L82.4873 50.3757L72.912 16.3203C72.912 16.3203 66.3712 22.5041 70.3875 34.9227C71.8027 39.2577 72.8355 42.2157 77.4255 51.791Z",
    fill: "url(#paint4_linear_1_6936)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4529 55.361L77.4639 51.7273L82.5129 50.312L83.7369 54.647L79.4529 55.361Z",
    fill: "url(#paint5_linear_1_6936)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1325 35.6365C79.4421 35.6365 81.3145 33.7641 81.3145 31.4545C81.3145 29.1448 79.4421 27.2725 77.1325 27.2725C74.8228 27.2725 72.9504 29.1448 72.9504 31.4545C72.9504 33.7641 74.8228 35.6365 77.1325 35.6365Z",
    fill: "url(#paint6_linear_1_6936)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1324 34.1703C78.6323 34.1703 79.8482 32.9544 79.8482 31.4545C79.8482 29.9547 78.6323 28.7388 77.1324 28.7388C75.6325 28.7388 74.4166 29.9547 74.4166 31.4545C74.4166 32.9544 75.6325 34.1703 77.1324 34.1703Z",
    fill: "url(#paint7_linear_1_6936)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2668 60.2188C85.0118 60.2826 84.7568 60.1423 84.693 59.9001L80.7278 45.8113C80.664 45.5563 80.8043 45.3013 81.0465 45.2375C81.3015 45.1738 81.5565 45.314 81.6203 45.5563L85.5855 59.6323C85.662 59.8873 85.509 60.1423 85.2668 60.2188Z",
    fill: "url(#paint8_linear_1_6936)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3724 65.0396L81.0021 65.1353L84.4382 78.4427L84.8086 78.3471L81.3724 65.0396Z",
    fill: "#515151"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2389 67.5636L88.8685 67.6592L92.3047 80.9667L92.675 80.871L89.2389 67.5636Z",
    fill: "#515151"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3155 57.9639L88.9452 58.0596L92.3813 71.3671L92.7517 71.2714L89.3155 57.9639Z",
    fill: "#515151"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8829 66.7897L85.5131 66.8872L87.5223 74.5067L87.8922 74.4092L85.8829 66.7897Z",
    fill: "#515151"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M150.636 117.683C150.636 117.683 155.494 106.489 161.346 105.099C162.277 104.882 163.169 105.622 163.105 106.565C162.978 108.605 161.231 112.724 152.383 119.596L150.636 117.683Z",
    fill: "url(#paint9_linear_1_6936)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M151.312 118.449C151.388 118.347 161.932 105.979 161.932 105.979C159.676 109.154 151.592 118.512 151.503 118.614L151.312 118.449Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M148.927 116.421C148.927 116.421 150.113 102.396 155.978 98.7112C156.909 98.1247 158.158 98.6092 158.439 99.6675C159.051 101.95 158.668 107.088 151.528 117.862L148.927 116.421Z",
    fill: "url(#paint10_linear_1_6936)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M149.947 117.007C149.998 116.867 156.947 99.4634 156.947 99.4634C155.659 103.76 150.266 116.982 150.215 117.109L149.947 117.007Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M171.278 120.935C171.278 120.935 167.836 111.359 159.37 115.12C159.37 115.12 155.787 116.752 151.873 112.685C151.873 112.685 144.605 103.327 137.605 106.438C137.605 106.438 134.188 107.751 132.403 114.1C132.403 114.1 123.44 113.794 122.318 120.96L171.278 120.935Z",
    fill: "url(#paint11_linear_1_6936)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1547 114.547C45.1547 114.547 40.1822 103.403 43.0892 98.1502C43.5482 97.3087 44.6957 97.1557 45.3587 97.8442C46.774 99.3232 48.6355 103.378 47.7302 114.547H45.1547Z",
    fill: "url(#paint12_linear_1_6936)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1875 114.56C46.1747 114.432 44.1475 98.3032 44.1475 98.3032C44.9635 102.103 46.417 114.394 46.4297 114.521L46.1875 114.56Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1583 116.663C42.1583 116.663 29.8672 105.354 30.696 97.1557C30.8235 95.8552 32.175 95.0392 33.3863 95.5492C35.9618 96.633 40.5008 100.739 45.4096 115.261L42.1583 116.663Z",
    fill: "url(#paint13_linear_1_6936)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M43.459 116.128C43.3698 115.975 32.1115 96.7988 32.1115 96.7988C35.197 101.134 43.663 115.809 43.765 115.949L43.459 116.128Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0424 121.011C26.0424 121.011 30.2499 109.281 40.6539 113.884C40.6539 113.884 45.0527 115.886 49.8595 110.888C49.8595 110.888 58.759 99.3873 67.3653 103.187C67.3653 103.187 71.5728 104.793 73.7658 112.596C73.7658 112.596 84.7691 112.201 86.1717 120.999L26.0424 121.011Z",
    fill: "url(#paint14_linear_1_6936)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3568 120.986C50.3568 120.986 54.5643 110.786 61.3601 114.98C61.3601 114.98 64.1651 118.181 67.3654 115.376C67.3654 115.376 73.1667 107.573 79.7712 110.378C86.3757 113.183 88.7728 120.986 88.7728 120.986H50.3568Z",
    fill: "url(#paint15_linear_1_6936)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2804 83.5007C56.3369 83.5007 55.5591 84.2784 55.5591 85.2219H55.1766C55.1766 84.0617 56.1201 83.1182 57.2804 83.1182C58.4407 83.1182 59.3842 84.0617 59.3842 85.2219H59.0017C59.0017 84.2784 58.2239 83.5007 57.2804 83.5007Z",
    fill: "url(#paint16_linear_1_6936)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3066 57.4523L36.7146 57.567C37.1863 57.0315 37.9258 56.7765 38.6653 56.9805C39.6853 57.261 40.2846 58.3193 40.0041 59.3265C39.7236 60.3465 38.6653 60.9458 37.6581 60.6653C36.9823 60.474 36.4851 59.9385 36.3193 59.301L35.8986 59.1863C36.0388 60.0405 36.6636 60.78 37.5561 61.035C38.7801 61.3665 40.0423 60.6525 40.3738 59.4285C40.7053 58.2045 39.9913 56.9423 38.7673 56.6108C37.8111 56.3558 36.8548 56.7255 36.3066 57.4523Z",
    fill: "url(#paint17_linear_1_6936)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3334 26.5462C52.0529 26.3167 51.8999 25.9852 51.9126 25.6282V25.3859C51.9126 25.1309 51.7979 24.9014 51.6066 24.7484C51.4026 24.5954 51.1476 24.5572 50.9054 24.6337C50.5484 24.7484 50.1531 24.6847 49.8471 24.4552C49.5411 24.2257 49.3754 23.8687 49.3881 23.4862L49.4009 23.2439C49.4136 23.0017 49.3116 22.7849 49.1331 22.6319C48.9546 22.4789 48.7124 22.4152 48.4829 22.4662L48.4064 22.0964C48.7506 22.0199 49.1076 22.1219 49.3881 22.3514C49.6559 22.5809 49.8089 22.9252 49.7961 23.2694L49.7834 23.5117C49.7706 23.7667 49.8854 24.0089 50.0894 24.1619C50.2934 24.3149 50.5484 24.3659 50.7906 24.2767C51.1476 24.1619 51.5301 24.2257 51.8361 24.4424C52.1421 24.6719 52.3079 25.0162 52.3079 25.3859V25.6282C52.3079 25.8704 52.4099 26.0999 52.6139 26.2529C52.8051 26.4059 53.0601 26.4442 53.3024 26.3804L53.3916 26.3549C53.7486 26.2529 54.1184 26.3167 54.4117 26.5334C54.7049 26.7502 54.8707 27.0944 54.8707 27.4642H54.4882C54.4882 27.2219 54.3734 26.9924 54.1822 26.8394C53.9909 26.6864 53.7359 26.6482 53.5064 26.7119L53.4171 26.7374C53.0601 26.8394 52.6904 26.7757 52.3971 26.5462C52.3589 26.5589 52.3461 26.5462 52.3334 26.5462Z",
    fill: "url(#paint18_linear_1_6936)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M145.511 23.9581C144.567 23.9581 143.79 23.1803 143.79 22.2368H143.407C143.407 23.3971 144.351 24.3406 145.511 24.3406C146.671 24.3406 147.615 23.3971 147.615 22.2368H147.232C147.232 23.1803 146.454 23.9581 145.511 23.9581Z",
    fill: "url(#paint19_linear_1_6936)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M147.525 89.8118H141.852L144.784 85.311L147.525 89.8118ZM142.757 89.3146H146.646L144.771 86.229L142.757 89.3146Z",
    fill: "url(#paint20_linear_1_6936)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M160.135 55.5525C159.804 55.6927 159.434 55.6672 159.128 55.5015L158.911 55.3867C158.694 55.2592 158.427 55.2592 158.21 55.3612C157.98 55.476 157.827 55.68 157.789 55.9222C157.725 56.292 157.483 56.6107 157.139 56.7637C156.795 56.9167 156.399 56.904 156.068 56.7127L155.851 56.5852C155.647 56.4705 155.405 56.445 155.175 56.5342C154.946 56.6235 154.793 56.802 154.716 57.0315L154.347 56.9167C154.449 56.5725 154.691 56.3047 155.035 56.1772C155.367 56.0497 155.736 56.0752 156.042 56.2537L156.259 56.3812C156.476 56.5087 156.744 56.5215 156.973 56.4195C157.203 56.3175 157.368 56.1007 157.407 55.8585C157.47 55.4887 157.7 55.1827 158.044 55.017C158.388 54.8512 158.771 54.864 159.102 55.0552L159.319 55.17C159.536 55.2847 159.791 55.2975 160.02 55.1955C160.25 55.0935 160.403 54.8895 160.454 54.6472L160.467 54.558C160.543 54.201 160.773 53.895 161.104 53.742C161.436 53.589 161.818 53.6017 162.137 53.7675L161.958 54.099C161.742 53.9842 161.487 53.9715 161.27 54.0735C161.053 54.1755 160.887 54.3795 160.836 54.6217L160.824 54.711C160.747 55.0807 160.518 55.374 160.173 55.527C160.161 55.5397 160.148 55.5525 160.135 55.5525Z",
    fill: "url(#paint21_linear_1_6936)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7428 59.2112C61.7428 59.2112 64.4203 58.7012 65.0578 55.3862C65.0578 55.3862 65.7591 58.6375 68.4366 59.1475C68.4366 59.1475 65.5041 60.295 65.1216 62.9725C65.1216 62.9725 64.4841 59.785 61.7428 59.2112Z",
    fill: "url(#paint22_linear_1_6936)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8977 55.8582C56.8977 55.8582 59.0142 55.4502 59.5242 52.8364C59.5242 52.8364 60.0725 55.4119 62.189 55.8072C62.189 55.8072 59.8685 56.7124 59.5625 58.829C59.5625 58.829 59.0652 56.3044 56.8977 55.8582Z",
    fill: "url(#paint23_linear_1_6936)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3058 62.6795C57.3058 62.6795 59.1035 62.3353 59.537 60.104C59.537 60.104 60.0088 62.297 61.8066 62.6285C61.8066 62.6285 59.8303 63.4063 59.5753 65.204C59.5753 65.204 59.1418 63.062 57.3058 62.6795Z",
    fill: "url(#paint24_linear_1_6936)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8727 27.4642C93.8727 27.4642 96.5502 26.9542 97.1877 23.6392C97.1877 23.6392 97.889 26.8904 100.566 27.4004C100.566 27.4004 97.6339 28.5479 97.2514 31.2254C97.2514 31.2254 96.6139 28.0379 93.8727 27.4642Z",
    fill: "url(#paint25_linear_1_6936)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0278 24.1106C89.0278 24.1106 91.1443 23.7026 91.6543 21.0889C91.6543 21.0889 92.2026 23.6644 94.3191 24.0596C94.3191 24.0596 91.9986 24.9649 91.6926 27.0814C91.6926 27.0814 91.1953 24.5569 89.0278 24.1106Z",
    fill: "url(#paint26_linear_1_6936)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4357 30.932C89.4357 30.932 91.2334 30.5877 91.6669 28.3564C91.6669 28.3564 92.1387 30.5495 93.9364 30.881C93.9364 30.881 91.9602 31.6587 91.7052 33.4565C91.7052 33.4565 91.2717 31.3145 89.4357 30.932Z",
    fill: "url(#paint27_linear_1_6936)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M131.702 37.4217C131.702 37.5237 127.342 37.919 127.342 37.919L127.074 36.083L126.844 34.4765V34.451C120.699 36.032 122.586 29.5932 122.586 29.5932L121.795 28.9047C121.795 28.9047 123.185 27.6169 123.682 26.7244C124.18 25.8319 125.365 24.1489 125.365 24.1489L131.307 25.8319L131.014 31.9775C131.014 31.9775 131.702 37.3197 131.702 37.4217Z",
    fill: "#FFC0BF"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M106.814 105.941L105.616 108.58L104.902 110.136L101.612 108.912L102.479 106.566L103.282 104.373L106.814 105.941Z",
    fill: "#FFC0BF"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M104.838 112.073L105.157 109.638C105.157 109.638 102.798 110.084 101.829 108.287L95.0715 109.549C94.7017 109.613 94.689 110.135 95.046 110.237L104.009 112.622C104.405 112.724 104.787 112.469 104.838 112.073Z",
    fill: "url(#paint28_linear_1_6936)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M128.795 100.42L125.926 102.435L125.416 101.734L123.134 98.4823L126.424 96.4678L127.546 98.3293L128.795 100.42Z",
    fill: "#FFC0BF"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M106.814 105.941L105.616 108.58L102.479 106.566L103.282 104.373L106.814 105.941Z",
    fill: "#EFA3B2"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M127.546 98.3293L125.416 101.734L123.134 98.4823L126.424 96.4678L127.546 98.3293Z",
    fill: "#EFA3B2"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M130.351 101.568L128.528 99.9229C128.528 99.9229 127.559 102.116 125.531 101.899L122.739 108.172C122.586 108.516 123.007 108.822 123.287 108.58L130.338 102.562C130.644 102.307 130.657 101.835 130.351 101.568Z",
    fill: "url(#paint29_linear_1_6936)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M117.333 77.9417L118.378 79.9562L121.795 86.5352L127.775 98.0485L122.407 102.957L118.021 96.2253L113.788 89.7355L108.153 81.1419C106.304 79.4207 106.317 76.4882 108.178 74.7669L125.008 60.0278L137.835 62.9093C135.973 67.4611 117.333 77.9417 117.333 77.9417Z",
    fill: "url(#paint30_linear_1_6936)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M121.795 86.5351L118.009 96.2506L113.776 89.7481L118.378 79.9561L121.795 86.5351Z",
    fill: "url(#paint31_linear_1_6936)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M138.217 60.028C138.217 60.028 138.217 60.1937 138.179 60.5125C138.039 61.6855 137.338 64.9622 134.023 69.973C133.691 70.4703 133.334 70.9803 132.952 71.5158C130.618 74.7415 127.265 78.6048 122.407 82.9908L109.109 108.3L102.415 106.438L115.216 76.3735L123.81 63.2665L124.384 62.3867L126.245 59.5435L135.221 59.9005L138.217 60.028Z",
    fill: "url(#paint32_linear_1_6936)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M138.218 60.028C138.218 60.028 138.218 60.1937 138.179 60.5125C138.039 61.6855 137.338 64.9622 134.023 69.973C133.691 70.4703 133.334 70.9803 132.952 71.5158C132.773 65.4212 125.926 63.6617 123.81 63.2665L124.384 62.3867L126.245 59.5435L135.221 59.9005L138.218 60.028Z",
    fill: "url(#paint33_linear_1_6936)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M125.939 45.3525V53.3978L124.932 53.079L122.637 52.365L122.14 45.2632L122.127 45.1357L125.939 45.3525Z",
    fill: "#FFC0BF"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M125.939 45.3525V53.3978L124.932 53.079L123.963 46.8442L122.14 45.2632L122.127 45.1357L125.939 45.3525Z",
    fill: "#EFA3B2"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M139.939 46.1556C139.913 46.7676 139.875 47.4561 139.824 48.2211C139.556 52.4924 138.931 59.097 137.542 65.8035C137.465 66.186 137.006 66.3645 136.687 66.135C135.438 65.2297 133.347 63.4575 128.935 63.1642C125.008 62.8965 123.657 62.1697 123.185 61.7107C123.007 61.5322 122.981 61.2517 123.109 61.035C123.44 60.4867 124.562 58.536 125.021 56.6107C125.174 55.9859 125.251 55.3484 125.225 54.7747C125.225 54.7364 125.225 54.7109 125.225 54.6727C125.238 54.5579 125.225 54.1499 125.187 53.5634C125.034 51.3067 124.588 46.4361 124.486 45.9389C124.486 45.9389 122.191 45.3014 122.14 45.1739L122.229 41.6294V41.6166C122.216 41.3489 122.458 37.6513 127.074 36.3508C127.176 36.3253 127.507 37.5111 128.68 37.4091C130.083 37.2816 131.409 35.4966 131.485 35.4966C132.786 35.5093 138.664 37.4601 139.9 43.4144C139.9 43.4271 140.015 44.4344 139.939 46.1556Z",
    fill: "url(#paint34_linear_1_6936)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M120.253 48.5654L130.172 52.9005V53.7292L122.114 52.9005L120.253 48.5654Z",
    fill: "url(#paint35_linear_1_6936)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M139.939 46.1558C139.913 46.7678 139.875 47.4563 139.824 48.2213C138.217 52.2503 135.043 59.6963 133.27 59.9768C132.085 60.1681 127.099 57.6691 125.021 56.6236C125.174 55.9988 125.251 55.3613 125.225 54.7876C125.225 54.7493 125.225 54.7238 125.225 54.6856C125.238 54.5708 125.225 54.1628 125.187 53.5763L132.123 55.3868L136.713 47.8643L139.939 46.1558Z",
    fill: "url(#paint36_linear_1_6936)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M130.172 53.7293L122.739 53.5253L122.114 52.2886L130.172 52.9006V53.7293Z",
    fill: "url(#paint37_linear_1_6936)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M106.317 37.0266L120.215 41.5274C120.623 41.6677 120.929 42.0119 121.005 42.4454L122.752 53.5125L110.282 49.356C109.938 49.2412 109.67 48.9734 109.555 48.6292L105.845 37.4984C105.743 37.2179 106.011 36.9374 106.317 37.0266Z",
    fill: "url(#paint38_linear_1_6936)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M138.077 50.2997L136.891 52.3907L133.959 57.529C133.742 58.0007 133.194 58.2302 132.709 58.0517L122.012 54.0482L119.539 53.6785L116.236 52.0209L115.612 51.1539L122.739 53.2704L131.715 53.6275L133.398 48.3872L133.525 47.8262L138.077 50.2997Z",
    fill: "#FFC0BF"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M138.077 50.2997L136.879 52.3907L133.398 48.3872L133.538 47.8262L138.077 50.2997Z",
    fill: "#EFA3B2"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M114.528 44.0008C114.783 44.6383 114.604 45.3013 114.133 45.4925C113.661 45.6838 113.062 45.3268 112.807 44.6893C112.552 44.0518 112.73 43.3888 113.202 43.1975C113.674 43.0063 114.273 43.376 114.528 44.0008Z",
    fill: "url(#paint39_linear_1_6936)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M135.043 41.7827L133.321 48.2597L138.154 50.746L139.441 47.5202C139.441 47.5202 140.755 43.708 139.276 41.566C138.919 41.0432 138.613 40.4057 137.746 40.1762C136.573 39.8447 135.361 40.597 135.043 41.7827Z",
    fill: "url(#paint40_linear_1_6936)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M133.64 27.1709C133.64 27.1709 133.755 25.8066 132.251 23.9451C131.218 22.6701 126.755 19.3933 124.575 23.2566C122.701 26.5716 127.469 27.8466 128.859 28.1399L128.145 29.8994L129.038 30.1926C129.038 30.1926 131.243 28.9941 130.861 31.0341C130.759 31.5569 130.606 31.8246 130.007 32.5131L131.116 33.0741C131.103 33.0741 135.91 31.0341 133.64 27.1709Z",
    fill: "url(#paint41_linear_1_6936)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M129.063 33.7119C128.897 34.5917 127.852 35.5097 127.087 36.0834L126.857 34.4769C127.89 34.1709 129.063 33.7119 129.063 33.7119Z",
    fill: "#EFA3B2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_6936",
    x1: 95.4942,
    y1: 58.1542,
    x2: 87.233,
    y2: 47.0237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2509,
    stopColor: "#8990F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DDEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_6936",
    x1: 78.7604,
    y1: 23.259,
    x2: 85.9639,
    y2: 60.8903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA655C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_6936",
    x1: 75.9846,
    y1: 62.6171,
    x2: 76.4715,
    y2: 49.5485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2509,
    stopColor: "#8990F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DDEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_6936",
    x1: 85.4479,
    y1: 64.3416,
    x2: 84.7634,
    y2: 45.9987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B233C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#635C70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_6936",
    x1: 67.892,
    y1: 19.1647,
    x2: 78.184,
    y2: 40.2011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD4B47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_6936",
    x1: 83.0648,
    y1: 55.0317,
    x2: 77.5083,
    y2: 49.1478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B233C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#635C70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_6936",
    x1: 73.1169,
    y1: 32.5763,
    x2: 81.1575,
    y2: 30.317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B233C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#635C70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1_6936",
    x1: 74.5172,
    y1: 32.1828,
    x2: 79.7571,
    y2: 30.7105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2509,
    stopColor: "#8990F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DDEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1_6936",
    x1: 82.8741,
    y1: 60.4107,
    x2: 83.3482,
    y2: 47.6886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2509,
    stopColor: "#8990F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DDEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1_6936",
    x1: 159.565,
    y1: 108.745,
    x2: 151.927,
    y2: 118.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB53FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF87FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1_6936",
    x1: 150.324,
    y1: 115.662,
    x2: 155.959,
    y2: 102.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64D7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6577FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1_6936",
    x1: 171.265,
    y1: 113.342,
    x2: 122.305,
    y2: 113.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#29056B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C93F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1_6936",
    x1: 44.5919,
    y1: 101.924,
    x2: 46.6369,
    y2: 114.146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB53FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF87FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1_6936",
    x1: 42.4697,
    y1: 114.796,
    x2: 34.2649,
    y2: 99.9593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64D7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6577FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1_6936",
    x1: 74.6115,
    y1: 111.71,
    x2: 29.4718,
    y2: 111.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#29056B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C93F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1_6936",
    x1: 50.3542,
    y1: 115.38,
    x2: 88.7728,
    y2: 115.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64D7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6577FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1_6936",
    x1: 55.1766,
    y1: 84.17,
    x2: 59.3842,
    y2: 84.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA655C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1_6936",
    x1: 37.6184,
    y1: 61.0587,
    x2: 38.8361,
    y2: 56.633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C681E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7057E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1_6936",
    x1: 48.2296,
    y1: 22.3077,
    x2: 54.7536,
    y2: 27.5833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2509,
    stopColor: "#8990F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DDEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1_6936",
    x1: 143.407,
    y1: 23.2887,
    x2: 147.615,
    y2: 23.2887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64D7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6577FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1_6936",
    x1: 141.843,
    y1: 87.5606,
    x2: 147.52,
    y2: 87.5606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C681E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7057E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1_6936",
    x1: 154.482,
    y1: 57.1833,
    x2: 162.205,
    y2: 53.9046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA655C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1_6936",
    x1: 61.7428,
    y1: 59.1794,
    x2: 68.4366,
    y2: 59.1794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA655C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1_6936",
    x1: 56.8977,
    y1: 55.8306,
    x2: 62.189,
    y2: 55.8306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA655C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1_6936",
    x1: 57.3028,
    y1: 62.6519,
    x2: 61.8066,
    y2: 62.6519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA655C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1_6936",
    x1: 93.8727,
    y1: 27.4323,
    x2: 100.566,
    y2: 27.4323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64D7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6577FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1_6936",
    x1: 89.0278,
    y1: 24.083,
    x2: 94.3191,
    y2: 24.083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64D7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6577FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1_6936",
    x1: 89.4327,
    y1: 30.9043,
    x2: 93.9364,
    y2: 30.9043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64D7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6577FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1_6936",
    x1: 101.137,
    y1: 113.62,
    x2: 99.4931,
    y2: 108.219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B233C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#635C70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1_6936",
    x1: 129.505,
    y1: 105.494,
    x2: 124.124,
    y2: 103.784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B233C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#635C70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1_6936",
    x1: 122.45,
    y1: 71.7237,
    x2: 126.946,
    y2: 107.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B233C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#635C70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1_6936",
    x1: 120,
    y1: 90.2434,
    x2: 114.517,
    y2: 83.7409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B233C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#635C70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1_6936",
    x1: 104.742,
    y1: 105.752,
    x2: 130.15,
    y2: 64.1376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B233C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#635C70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1_6936",
    x1: 135.452,
    y1: 58.2,
    x2: 127.282,
    y2: 68.4375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B233C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#635C70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1_6936",
    x1: 128.125,
    y1: 37.1737,
    x2: 134.035,
    y2: 64.1386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64D7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6577FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_1_6936",
    x1: 120.259,
    y1: 51.1514,
    x2: 130.169,
    y2: 51.1514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B233C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#635C70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1_6936",
    x1: 136.705,
    y1: 37.7761,
    x2: 132.239,
    y2: 51.7146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64D7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6577FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1_6936",
    x1: 124.908,
    y1: 53.0098,
    x2: 132.961,
    y2: 53.0098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B233C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#635C70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_1_6936",
    x1: 105.816,
    y1: 45.2698,
    x2: 122.737,
    y2: 45.2698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B233C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#635C70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_1_6936",
    x1: 112.798,
    y1: 44.7016,
    x2: 114.525,
    y2: 44.0084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7C4EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_1_6936",
    x1: 137.907,
    y1: 39.4516,
    x2: 136.025,
    y2: 50.3259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64D7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6577FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_1_6936",
    x1: 124.141,
    y1: 27.2508,
    x2: 134.249,
    y2: 27.2508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B233C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#635C70"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFellowship);
export default __webpack_public_path__ + "static/media/fellowship.cbf071b5d010b95e74c113c92eaa38bb.svg";
export { ForwardRef as ReactComponent };